import RatedAll from './RatedAll';

export default RatedAll;
